import { render } from "./thirdBox.vue?vue&type=template&id=6b66ca6c"
import script from "./thirdBox.vue?vue&type=script&lang=js"
export * from "./thirdBox.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/mixins/thrid-register/thirdBox.vue'],['render',render],['__file',"thirdBox.vue"]])

export default __exports__